const route = {
	path: '/rules',
	name: 'accounting-rules',
	meta: {
		title: 'Lista de Reglas Contables',
	},
	component: () => import('@/pages/rules/page-rules'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/rules.js